/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { AppSettingsCommandParams } from '../models/app-settings-command-params';
import { AppSettingsCountryCommandParams } from '../models/app-settings-country-command-params';
import { AppSettingsModel } from '../models/app-settings-model';
import { Country } from '../models/country';

@Injectable({ providedIn: 'root' })
export class AppSettingsApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateAppSetting()` */
  static readonly UpdateAppSettingPath = '/api/v1/appsettings/{appSettingsId}';

  /**
   * Update appSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAppSetting$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAppSetting$Plain$Response(
    params: {
      appSettingsId: number;
      body: AppSettingsCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppSettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, AppSettingsApiClient.UpdateAppSettingPath, 'patch');
    if (params) {
      rb.path('appSettingsId', params.appSettingsId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppSettingsModel>;
      })
    );
  }

  /**
   * Update appSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAppSetting$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAppSetting$Plain(
    params: {
      appSettingsId: number;
      body: AppSettingsCommandParams
    },
    context?: HttpContext
  ): Observable<AppSettingsModel> {
    return this.updateAppSetting$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppSettingsModel>): AppSettingsModel => r.body)
    );
  }

  /**
   * Update appSettings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAppSetting()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAppSetting$Response(
    params: {
      appSettingsId: number;
      body: AppSettingsCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppSettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, AppSettingsApiClient.UpdateAppSettingPath, 'patch');
    if (params) {
      rb.path('appSettingsId', params.appSettingsId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppSettingsModel>;
      })
    );
  }

  /**
   * Update appSettings.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAppSetting$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAppSetting(
    params: {
      appSettingsId: number;
      body: AppSettingsCommandParams
    },
    context?: HttpContext
  ): Observable<AppSettingsModel> {
    return this.updateAppSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppSettingsModel>): AppSettingsModel => r.body)
    );
  }

  /** Path part for operation `updateAppSettingCountry()` */
  static readonly UpdateAppSettingCountryPath = '/api/v1/appsettings/{appSettingsId}/{country}';

  /**
   * Update appSettings country with legal informations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAppSettingCountry$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAppSettingCountry$Plain$Response(
    params: {
      appSettingsId: number;
      country: Country;
      body: AppSettingsCountryCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppSettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, AppSettingsApiClient.UpdateAppSettingCountryPath, 'post');
    if (params) {
      rb.path('appSettingsId', params.appSettingsId, {});
      rb.path('country', params.country, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppSettingsModel>;
      })
    );
  }

  /**
   * Update appSettings country with legal informations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAppSettingCountry$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAppSettingCountry$Plain(
    params: {
      appSettingsId: number;
      country: Country;
      body: AppSettingsCountryCommandParams
    },
    context?: HttpContext
  ): Observable<AppSettingsModel> {
    return this.updateAppSettingCountry$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppSettingsModel>): AppSettingsModel => r.body)
    );
  }

  /**
   * Update appSettings country with legal informations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAppSettingCountry()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAppSettingCountry$Response(
    params: {
      appSettingsId: number;
      country: Country;
      body: AppSettingsCountryCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppSettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, AppSettingsApiClient.UpdateAppSettingCountryPath, 'post');
    if (params) {
      rb.path('appSettingsId', params.appSettingsId, {});
      rb.path('country', params.country, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppSettingsModel>;
      })
    );
  }

  /**
   * Update appSettings country with legal informations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAppSettingCountry$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateAppSettingCountry(
    params: {
      appSettingsId: number;
      country: Country;
      body: AppSettingsCountryCommandParams
    },
    context?: HttpContext
  ): Observable<AppSettingsModel> {
    return this.updateAppSettingCountry$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppSettingsModel>): AppSettingsModel => r.body)
    );
  }

  /** Path part for operation `getAppSetting()` */
  static readonly GetAppSettingPath = '/api/v1/appsettings';

  /**
   * Get appSettings for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAppSetting$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppSetting$Plain$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppSettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, AppSettingsApiClient.GetAppSettingPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppSettingsModel>;
      })
    );
  }

  /**
   * Get appSettings for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAppSetting$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppSetting$Plain(
    params?: {
    },
    context?: HttpContext
  ): Observable<AppSettingsModel> {
    return this.getAppSetting$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppSettingsModel>): AppSettingsModel => r.body)
    );
  }

  /**
   * Get appSettings for the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAppSetting()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppSetting$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppSettingsModel>> {
    const rb = new RequestBuilder(this.rootUrl, AppSettingsApiClient.GetAppSettingPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppSettingsModel>;
      })
    );
  }

  /**
   * Get appSettings for the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAppSetting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAppSetting(
    params?: {
    },
    context?: HttpContext
  ): Observable<AppSettingsModel> {
    return this.getAppSetting$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppSettingsModel>): AppSettingsModel => r.body)
    );
  }

}
